/**
 * Funkcje pomocnicze dla harmonogramu realizacji
 */
export const PHASES = [
    { key: 'inicjacja', name: 'Etap inicjacji' },
    { key: 'przygotowania', name: 'Etap przygotowania' },
    { key: 'realizacja', name: 'Etap realizacji' },
    { key: 'zamykania', name: 'Etap zamykania' },
]

export const determineStatus = (items) => {
    const evaluations = items.map((item) => item.ocena).filter(Boolean)

    const startedEvaluations = evaluations.filter((e) => e !== 'Nie rozpoczęty')
    if (startedEvaluations.length === 0)
        return { label: 'Nie rozpoczęty', variant: 'secondary' }

    if (startedEvaluations.some((ocena) => ocena === 'Jest problem!')) {
        return { label: 'Jest problem!', variant: 'danger' }
    }
    if (startedEvaluations.some((ocena) => ocena === 'Mogą wystąpić problemy')) {
        return { label: 'Mogą wystąpić problemy', variant: 'warning' }
    }
    if (startedEvaluations.every((ocena) => ocena === 'Zgodnie z planem')) {
        return { label: 'Zgodnie z planem', variant: 'success' }
    }

    return { label: '-', variant: 'info' }
}

export const processPhasesData = (formData) => {
    return PHASES.map((phase) => {
        const listKey = `${phase.key}_zadania_list`
        const rawTasks = formData[listKey] || []

        const tasks = rawTasks.map((t, idx) => ({
            id: `${phase.key}-${idx}`,
            index: idx,
            listKey: listKey,
            nazwa: t.nazwa || 'Bez nazwy',
            start: t.data_rozpoczecia || (t.czy_kamien_milowy === 'Tak' ? t.data_zakonczenia : '-') || '-',
            koniec: t.data_zakonczenia || '-',
            isMilestone: t.czy_kamien_milowy === 'Tak',
            budzet_planowany: parseFloat(t.budzet_planowany || 0),
            wydatkowanie_narastajaco: parseFloat(
                t.realizacja_wydatkowanie_narastajaco || 0
            ),
            ocena: t.realizacja_ocena,
        }))

        const totalPlan = tasks.reduce(
            (sum, t) => sum + (t.isMilestone ? 0 : t.budzet_planowany),
            0
        )
        const totalSpent = tasks.reduce(
            (sum, t) => sum + t.wydatkowanie_narastajaco,
            0
        )
        const percent = totalPlan > 0 ? (totalSpent / totalPlan) * 100 : 0
        const status = determineStatus(tasks)

        return {
            ...phase,
            tasks,
            totalPlan,
            totalSpent,
            percent,
            status,
            listKey,
            rawTasks,
        }
    })
}

export const calculateSummary = (phasesData) => {
    const allTasks = phasesData.flatMap((p) => p.tasks)
    const totalPlan = phasesData.reduce((sum, p) => sum + p.totalPlan, 0)
    const totalSpent = phasesData.reduce((sum, p) => sum + p.totalSpent, 0)

    const starts = allTasks.map((t) => new Date(t.start)).filter((d) => !isNaN(d))
    const ends = allTasks.map((t) => new Date(t.koniec)).filter((d) => !isNaN(d))

    const minDate = starts.length
        ? new Date(Math.min(...starts)).toLocaleDateString('pl-PL')
        : '-'
    const maxDate = ends.length
        ? new Date(Math.max(...ends)).toLocaleDateString('pl-PL')
        : '-'

    const summaryStatus = determineStatus(
        phasesData
            .filter((p) => p.tasks.length > 0)
            .map((p) => ({ ocena: p.status.label }))
    )

    return {
        totalPlan,
        totalSpent,
        percent: totalPlan > 0 ? (totalSpent / totalPlan) * 100 : 0,
        range: `${minDate} — ${maxDate}`,
        status: summaryStatus,
    }
}

export default {
    PHASES,
    determineStatus,
    processPhasesData,
    calculateSummary,
}
